import { render, staticRenderFns } from "./ChannelFriendDetail.vue?vue&type=template&id=796e73d9&scoped=true&"
import script from "./ChannelFriendDetail.vue?vue&type=script&lang=js&"
export * from "./ChannelFriendDetail.vue?vue&type=script&lang=js&"
import style0 from "./ChannelFriendDetail.vue?vue&type=style&index=0&id=796e73d9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "796e73d9",
  null
  
)

export default component.exports